import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, TextInput, Textarea, Button, Title, Group, Loader } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useForm } from "@mantine/form";

export const checkUserName = async (email) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}auth/checkname/${email}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
    }
    const data = await response.json();
    return data;
  } catch (error) {

  }
};

const ModalEditorResponsible = ({ opened, onClose, onSave, responsibleData }) => {

  const { responsables } = useSelector((state) => state.improvementPlan);
  const isEdit = Boolean(responsibleData?.Id);
  const isSaving = isEdit ? responsables?.savingById[responsibleData?.Id] : responsables?.savingNew;

  const [usuario, setUsuario] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [isValidUser, setIsValidUser] = useState(null); 
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [typingTimeout, setTypingTimeout] = useState(null);

  const form = useForm({
    initialValues: {
       usuario: responsibleData?.usuarioMail ?? "",
       descripcion: responsibleData?.descripcion ?? "" },
    validate: {
      usuario :(value) => (value.trim() ? null : "El título es obligatorio"),
    },
  });

  useEffect(() => {
      if (opened && responsibleData) {
        form.setValues({
          usuario: responsibleData?.usuarioMail ?? "",
          descripcion: responsibleData?.descripcion ?? "",
        });
        handleUserChange(responsibleData.usuarioMail);
      } else if (opened && !responsibleData) {
        form.reset();
        setIsValidUser(null);
        setUsuario("");
      }
    }, [opened, responsibleData]);

  const handleUserChange = (value) => {
    setUsuario(value);
    setIsValidUser(null); 
    setIsButtonDisabled(true); 

    if (typingTimeout) {
        clearTimeout(typingTimeout); 
    }

    setTypingTimeout(
        setTimeout(async () => {
            setIsChecking(true); 
            try {
                const result = await checkUserName(value);
  
                if (result && result.SamAccountName) {
                    setIsValidUser(true); 
                    setIsButtonDisabled(false); 
                } else {
                    setIsValidUser(false); 
                    setIsButtonDisabled(true); 
                }
            } catch (error) {
                setIsValidUser(false); 
                setIsButtonDisabled(true);
            } finally {
                setIsChecking(false); 
            }
        }, 3000) 
    );
};

  const handleSubmit = () => {


    if (!form.validate().hasErrors) {

      const nuevoResponsible = {
        usuarioMail: form.values.usuario,
        descripcion: form.values.descripcion,
      };
      if (responsibleData) {
        nuevoResponsible.Id = responsibleData.Id;
      }
      onSave(nuevoResponsible);
      form.reset();
      setIsValidUser(null);
      onClose();
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title fw={450} c={"#e91e63"} size={"28px"}>CREAR RESPONSABLE</Title>}
      centered
      size="lg"
      closeOnEscape={!isSaving}
      closeOnClickOutside={!isSaving}
      closeButtonProps={{ disabled: isSaving }}
    >
      <TextInput
        label="Responsable"
        description="Debe ingresar un mail institucional valido"
        placeholder="nombre.apellido@uai.edu.ar"
        rightSection={
          isChecking ? (
            <Loader size="xs" />
          ) : isValidUser === true ? (
            <IconCheck color="green" />
          ) : isValidUser === false ? (
            <IconX color="red" />
          ) : null
        }
        {...form.getInputProps("usuario")}
        onChange={(e) => {
          const value = e.target.value;
          form.setFieldValue("usuario", value); 
          handleUserChange(value); 
        }}
      />
      <Textarea
        label="Responsabilidad"
        placeholder="Ingrese una descripcion sobre la responsabilidad de la persona"
        {...form.getInputProps("descripcion")}
        mt="md"
        autosize
        minRows={2}
        maxRows={4}
      />
      <Button
        fullWidth
        mt="md"
        color="#e91e63"
        onClick={handleSubmit}
        disabled={isButtonDisabled || isSaving}
        loading={isSaving}
      >
        Guardar Responsable
      </Button>
    </Modal>
  );
};

export default ModalEditorResponsible;
